import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["icon"];

  connect() {
  }

  copy(event) {
    event.preventDefault();
    // Find the input within this controller's element
    const input = this.element.querySelector("input[id^='token-display'], input[class^='token-display']");
    if (input) {
      input.select();
      document.execCommand("copy");
      this.showIcon();
    }
  }

  showIcon() {
    if (this.hasIconTarget) {
      this.iconTarget.classList.remove("invisible");
      setTimeout(() => {
        this.iconTarget.classList.add("invisible");
      }, 2000); // Hide icon after 2 seconds
    }
  }

}
